import { ReactSVG } from "react-svg"
import stadiumIcon from '@assets/icons/stadium2.svg'
import artificialIcon from '@assets/icons/pitch-type/artificial.svg'
import naturalIcon from '@assets/icons/pitch-type/natural.svg'
import hybridIcon from '@assets/icons/pitch-type/hybrid2.svg'
import { colors } from "shared-ui"
import { css } from "@emotion/react"
import { useMemo } from "react"

export default function PitchTypeIcon({ pitch, ...props }) {

    const { pitchType, grassType } = pitch ?? {}

    const iconSrc = useMemo(() => {
        return pitchType?.category === 'hybrid' ? hybridIcon
            : pitchType?.category === 'natural' ? naturalIcon
                : pitchType?.category === 'artificial' ? artificialIcon
                    : stadiumIcon
    }, [pitchType])

    const title = useMemo(() => {
        const typeStr = pitchType?.name ?? ''
        const grassStr = grassType?.name ?? ''
        const separator = (!!typeStr && !!grassStr) ? ', ' : ''
        return `${typeStr}${separator}${grassStr}`
    }, [pitchType, grassType])

    return <div css={style.wrapper} title={title} {...props}>
        <ReactSVG
            src={iconSrc}
            css={style.svg}
        />
    </div>
}

const style = {
    wrapper: css`
        align-self: center;
        height: 3em;
        width: 3em;
    `,
    svg: css`
        height: 100%;
        width: 100%;
        color: ${colors.main1};
        display: grid;
        align-items: center;
    `
}